import { polymorphicFactory, Box, Spacer, Grid, GridColumn } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import { ImageLink } from './subcomponents/ImageLink/ImageLink.mjs';
import classes from './TwoUpFeaturedCards.module.css.mjs';

const TwoUpFeaturedCards = polymorphicFactory(
  (props, ref) => {
    const { component = "section", mod = "white", variant = "default", cards, topSpacer, bottomSpacer, className, ...rest } = props;
    const isDefault = variant === "default";
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        component,
        className: clsx(
          "kohler-two-up-featured-cards-root",
          classes.twoUpFeaturedCardsModuleRoot,
          className,
          !isDefault && classes.twoUpFeaturedCardsModuleRootSpacious
        ),
        ref,
        mod,
        ...rest
      },
      topSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...topSpacer }),
      /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { className: clsx(!isDefault && classes.twoUpFeaturedCardsCardsGridColumnSpacious) }, /* @__PURE__ */ React.createElement(Box, { className: clsx(classes.twoUpFeaturedCardsCardsWrapper, !isDefault && classes.twoUpFeaturedCardsCardsWrapperSpacious) }, cards.map((card, index) => /* @__PURE__ */ React.createElement(ImageLink, { key: `${card.CTA.href}-${index}`, ...card, position: isDefault ? "middle-center" : "bottom-center" }))))),
      bottomSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...bottomSpacer })
    );
  }
);

export { TwoUpFeaturedCards };
